import {
    AbfLoanExpanded,
    useLoanDetail,
    useLoopscaleWalletContext,
    isLoanBorrower,
    useIsLoanLender,
    LoanStatus
} from "@bridgesplit/abf-react";
import { COPY } from "app/constants";

export function useLoanFromParams(loanAddress: string | undefined): {
    loanExpanded: AbfLoanExpanded | undefined;
    isLoading: boolean;
    notFound: boolean;
} {
    const { data: loanExpanded, isLoading, isFetching } = useLoanDetail(loanAddress);

    return {
        loanExpanded,
        isLoading,
        notFound: !loanExpanded && !isLoading && !isFetching && !!loanAddress
    };
}
export function useRolesFromLoan(loanExpanded: AbfLoanExpanded | undefined) {
    const {
        data: { userWalletAddress: activeWallet }
    } = useLoopscaleWalletContext();
    const isLender = useIsLoanLender(loanExpanded, activeWallet);
    const isBorrower = isLoanBorrower(loanExpanded, activeWallet);

    return { isLender, isBorrower };
}

export function useLoanStatusTooltipText(loanExpanded: AbfLoanExpanded | undefined) {
    const status = loanExpanded?.status;
    const { isBorrower, isLender } = useRolesFromLoan(loanExpanded);

    if (!status) return undefined;
    if (status === LoanStatus.RepaidLoan) {
        if (isBorrower) return "This position is closed and collateral has been returned to your wallet.";
        if (isLender)
            return `Repaid principal and interest have been collected to your ${COPY.STRATEGY_TERM.toLowerCase()}.`;
    }

    if (status === LoanStatus.DefaultedLoan) {
        if (isBorrower) return "This position was liquidated due to insufficient health. No collateral was returned.";
        if (isLender)
            return `This position was liquidated and full repayment has been collected to your ${COPY.STRATEGY_TERM.toLowerCase()}.`;
    }

    return undefined;
}
